<script>
export default {
  name: "Home"
}
</script>

<template>
  <div class="page">
    <img src="@/assets/logo_red.png" class="logo" alt="">
    <h1>{{ $t('欢迎使用本系统') }}</h1>
  </div>
</template>

<style scoped>

.page {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  align-items: center;
  justify-content: center;
}

.logo {
  width: 260px;
  height: 120px;
}
</style>
